import {createSvgIcon} from '../create-svg-icon';

export const PlaylistPlayIcon = createSvgIcon(
  <path d="M3 10h11v2H3zm0-4h11v2H3zm0 8h7v2H3zm13-1v8l6-4z" />
, 'PlaylistPlayOutlined');
